import script from "./PlatformCitiesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformCitiesTab.vue?vue&type=script&setup=true&lang=js"

import "./PlatformCitiesTab.vue?vue&type=style&index=0&id=0bef38f8&scoped=true&lang=css"
import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bef38f8"]])

export default __exports__